module.exports = __webpack_public_path__ + "static/media/logo-trans.95c0bfeb.png";